import odata from 'odata-client';
import {
  CREATE_EMPLOYEE_ORGANISATION_REQUEST,
  CREATE_EMPLOYEE_ORGANISATION_ERROR,
  CREATE_EMPLOYEE_ORGANISATION_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import { getServiceUrl, getDefaultHeader } from '../../utils';
import RESOURCES from '../../api/resources';
import { showNotification } from '../notification';

export const tokenExpired = () => ({
  type: TOKEN_EXPIRED
});

export const CreateEmployeeOrganisationRequest = () => ({
  type: CREATE_EMPLOYEE_ORGANISATION_REQUEST
});

export const CreateEmployeeOrganisationError = errorOrResult => ({
  type: CREATE_EMPLOYEE_ORGANISATION_ERROR,
  error: errorOrResult.message
});

export const CreateEmployeeOrganisationSuccess = payload => ({
  type: CREATE_EMPLOYEE_ORGANISATION_SUCCESS,
  payload
});

export default (employee, organisation) => async (dispatch, getState) => {

  dispatch(CreateEmployeeOrganisationRequest());

  const url = `${getServiceUrl()}${RESOURCES.Organisations}(${organisation.ID})`;
  const query = odata({ service: getServiceUrl() }).resource(RESOURCES.Employees, employee.ID).resource(RESOURCES.Organisations).resource(RESOURCES.Ref);
  const errorOrResult = await query.put({ "@odata.id": url }, {
    headers: {
      Authorization: `Bearer ${getState().user.token}`,
      ...getDefaultHeader()
    },
  })
    .then(resp => resp)
    .then(res => {
      const ok = res.statusCode <= 299 && res.statusCode >= 200;
      if (res.statusCode === 500) {
        const errorKey = "GENERAL_SERVER_ERROR";
        return new Error(errorKey);
      } else if (!ok) {
        console.log('Create employee organisation api error', res.toJSON());
        const body = JSON.parse(res.body);
        const { Error: { Message } } = body
        const errorKey = res.statusCode === 401 ? `401: ${Message}` : `${Message}`;
        return new Error(errorKey);
      } else {
        return organisation;
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      dispatch(showNotification("Request probably timed out.", "error"))
    })

  if (errorOrResult instanceof Error) {
    dispatch(CreateEmployeeOrganisationError(errorOrResult, CREATE_EMPLOYEE_ORGANISATION_ERROR));
    console.log("CODE ERROR: ", errorOrResult.message);
    if (errorOrResult.message.split(":")[0] === "401") {
      dispatch(tokenExpired());
      dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
    }
    dispatch(showNotification(errorOrResult.message.split(",")[1], "error"))
    return errorOrResult;
  } else {
    dispatch(showNotification("SUCCESSFUL_CREATE_EMPLOYEE_ORGANISATION", "success"))
  }

  dispatch(CreateEmployeeOrganisationSuccess(errorOrResult));

  return errorOrResult;
};